import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './UserRowsCard.module.scss';
import { useQuery, useQueryClient } from 'react-query';
import { getUsersRowsData } from 'posts/Requests';
import ServerError from '../ErrorBoundary/ServerError';
import { Grid, GridSize } from '@material-ui/core';
import CardTitle from '../CardTitle';
import UserInfo from '../UserInfo';
import DotsMenu from '../DotsMenu';
import { ExpandIcon } from 'app/assets/images/icons';

interface Props {
  slug: string;
  refetch?: any;
  customFilters: object;
  hideIfNoData?: boolean;
  compId: string;
  title: string;
  isReport: boolean;
  grid?: {
    xs?: GridSize;
    lg?: GridSize;
    md?: GridSize;
    sm?: GridSize;
    xl?: GridSize;
  };
  openModalToAddInfluencer?: any;
  expandAction?: () => void;
}

const UserRowsCard: FunctionComponent<Props> = ({
  slug,
  refetch,
  customFilters,
  hideIfNoData,
  compId,
  title,
  isReport,
  grid,
  openModalToAddInfluencer,
  expandAction,
}) => {
  useEffect(() => {
    setFilters({ ...customFilters, limit: 5 });
  }, [customFilters]);
  const [filters, setFilters] = useState({
    ...customFilters,
    limit: 5,
  });
  const handleChangeFilter = (val: any) => {
    setFilters({ ...filters, limit: val });
  };
  const {
    data: QData,
    isLoading,
    isError,
  } = useQuery(
    ['getCardData', { slug, body: filters }, refetch],
    getUsersRowsData,
    {
      enabled: !!slug,
    },
  );
  const queryClient = useQueryClient();
  useEffect(() => {
    return () => {
      queryClient.removeQueries(['getUsersRowsData']);
    };
  }, []);
  const data = QData;
  if (!data?.length && hideIfNoData && !isLoading) return <></>;
  return (
    <ServerError requiredApiCalls={[isError]}>
      <Grid item {...grid} id={compId}>
        <div
          id={`${compId}-UserRowsCard`}
          data-testid={`${compId}-UserRowsCard`}
          className="position-relative"
        >
          <CardTitle title={title} compId={compId} hideIcon={isReport} />
        </div>
        <div className={styles.UserRowsCard} id={`${compId}-UserRowsCard`}>
          <div className={styles.UserRowsCard__Actions}>
            <div>
              {expandAction ? <ExpandIcon onClick={expandAction} /> : null}
            </div>
            <div>{!isReport && <DotsMenu id={compId} />}</div>
          </div>
          {data?.map((row: any) => (
            <div className={styles.UserRowsCard__Row}>
              <UserInfo
                data={row}
                openModalToAddInfluencer={openModalToAddInfluencer}
                handleInfluencer={row?.influencer}
              />
            </div>
          ))}
        </div>
      </Grid>
    </ServerError>
  );

  {
    /* </div>; */
  }
};

export default UserRowsCard;
